module.exports = __webpack_public_path__ + "img/weixin.78289dfe.jpeg";